const CAMPOS = ['sugestao_ef', 'ef_sugerida_id', 'ef_sugerida_numero', 'ef_sugerida_valor'];
export function idsLeituraPendente(lista) {
    return lista.filter(f => f.sugestao_ef?.leitura?.estado === 'pendente').map(f => f.id);
}
export async function carregarSugestoesPendentes(api, ids) {
    const resultados = [];
    // Lotes sequenciais limitam carga e tamanho do pedido.
    for (let i = 0; i < ids.length; i += 100) {
        const { data } = await api.get('/gestao-financeira/faturas-reais/sugestoes-ef', {
            params: { ids: ids.slice(i, i + 100).join(',') }
        });
        if (!Array.isArray(data)) throw new Error('Resposta inválida ao atualizar sugestões.');
        resultados.push(...data);
    }
    return resultados;
}
export function fundirSugestoes(lista, resultados, originais) {
    const porId = new Map(resultados.map(r => [r.id, r]));
    let alterada = false;
    const proxima = lista.map(f => {
        const r = porId.get(f.id);
        // Não aplicar resultados anteriores a uma edição ou a um carregamento completo.
        if (!r || originais.get(f.id) !== f) return f;
        if (CAMPOS.every(c => JSON.stringify(f[c]) === JSON.stringify(r[c]))) return f;
        alterada = true;
        return { ...f, ...Object.fromEntries(CAMPOS.map(c => [c, r[c]])) };
    });
    return alterada ? proxima : lista;
}
